import React from 'react';
import styled from 'styled-components';
import Icon from 'shared/Icon';
import {Spinner} from 'react-bootstrap';
import {createPortal} from 'react-dom';
import {Toaster} from 'react-hot-toast';

interface PDFPreviewHeaderProps {
    title: string;
    isLoading: boolean;
    downloadHandler: () => void;
}

const PDFPreviewHeader = ({
    title,
    downloadHandler,
    isLoading,
}: PDFPreviewHeaderProps) => {
    return createPortal(
        <>
            <HeaderDiv className="pdf-header">
                <span className="header-title">{title}</span>
                <div className="header-actions">
                    {isLoading ? (
                        <Spinner
                            animation="border"
                            role="status"
                            style={{
                                width: '20px',
                                height: '20px',
                            }}>
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    ) : (
                        <button
                            className="download-btn"
                            onClick={downloadHandler}>
                            <Icon
                                style={{height: 28, width: 28}}
                                iconName={'Download.svg'}
                            />
                        </button>
                    )}
                </div>
            </HeaderDiv>
            <Toaster position="bottom-right" />
        </>,
        document.querySelector('.header-container')
    );
};

const HeaderDiv = styled.div`
    &.pdf-header {
        background: #3c3c3c;
        padding: 0 16px;
        font-size: 14px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;

        .header-title {
            flex: 1;
            text-align: left;
        }
        .header-actions {
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .download-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            margin-left: 8px;
            border-radius: 50px;
            transition: background 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            &:hover {
                background: rgba(0, 0, 0, 0.75);
            }
        }
    }
`;

export default PDFPreviewHeader;
